import React from 'react'
import { Typeahead } from 'react-bootstrap-typeahead'
import 'react-bootstrap-typeahead/css/Typeahead.css'

function StockSymbolInput({ symbols, selected, onSelect, onClear }) {
  return (
    <Typeahead
      id="stock-symbol-input"
      options={symbols}
      selected={selected ? [selected] : []}
      onChange={(selection) => {
        if (selection.length > 0) onSelect(selection[0])
        else onClear()
      }}
      placeholder="Enter a symbol (e.g. AAPL)…"
      clearButton
    />
  )
}

export default StockSymbolInput
